//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "SearchResultDocument",
  props: ["result"],
  computed: {
    ...mapGetters(["settings"]),
    ariaLabel() {
      return this.result.title ? "Click to go to " + this.result.title : '';
    },
  },
};
